import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { useSurveyContext } from './_store'
import Layout from './Layout'
import Landing from './Landing'

// SurveyStoreProvider wraps this component via SurveyTempEntry
const Survey = ({ type }) => {
  const { state } = useSurveyContext()
  const notStarted =
    Object.keys(state.pages).length === 0 && state.pages.constructor === Object

  // Render Landing until survey is started
  // Landing contains logic for starting the survey
  return (
    <Fragment>{notStarted ? <Landing type={type} /> : <Layout />}</Fragment>
  )
}

Survey.propTypes = {
  type: PropTypes.string.isRequired
}

export default Survey
